import React from "react";
import loadable from "@loadable/component";
import { tw } from "@careinfo/tailwind";
import CreateIcon from "../../Icons/CreateIcon";
import { useParams } from "react-router-dom";
import useGetHook from "../../customHooks/useGetHook";
import APIS from "../../constant/Endpoint";
import usePatchHook from "../../customHooks/usePatchHook";
import Spinner from "../../components/reusable/Spinner";
const EditHubComponent = loadable(() => import("../../components/Hub/EditHub"));
const EditHub = () => {
  const { id } = useParams();

  const { data, isLoading } = useGetHook({
    queryKey: ["hub", `hub-${id}`],
    url: `${APIS.HUB}${id}/`,
    params: {},
  });
  const { mutateAsync, isLoading: mutateAsyncLoading } = usePatchHook({
    queryKey: ["hub"],
    navigateURL: "/",
  });

  const handleEdit = async (values: any, setError: any) => {
    const url = `${APIS.HUB}${id}/`;
    let formData = {
      ...values,
    };
    try {
      await mutateAsync({ url, formData, setError });
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <>
      <div
        className={tw`w-full flex justify-left gap-x-2 mb-2 uppercase font-extrabold items-center`}
      >
        <CreateIcon />
        <span className={tw`text-[#5E5757] font-bold text-xl`}>Edit Hub</span>
      </div>
      {isLoading ? (
        <Spinner />
      ) : (
        <EditHubComponent
          handleEdit={handleEdit}
          isLoading={mutateAsyncLoading}
          data={data}
        />
      )}
    </>
  );
};

export default EditHub;
